var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPageSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Login Page Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.41,46.17a7.59,7.59,0,0,0,.08-1.07A9.45,9.45,0,0,0,48.41,44l2.31-1.81a.54.54,0,0,0,.13-.7l-2.2-3.79a.55.55,0,0,0-.67-.24L45.26,38.6a8.74,8.74,0,0,0-1.85-1.07L43,34.63a.57.57,0,0,0-.55-.46H38.06a.56.56,0,0,0-.54.46l-.4,2.91a7.94,7.94,0,0,0-1.85,1.08l-2.73-1.09a.55.55,0,0,0-.67.23l-2.17,3.8a.54.54,0,0,0,.13.7l2.31,1.81a9.3,9.3,0,0,0-.07,1.07,7.45,7.45,0,0,0,.08,1.06L29.84,48a.55.55,0,0,0-.12.7l2.19,3.79a.55.55,0,0,0,.67.23l2.73-1.11a7.94,7.94,0,0,0,1.85,1.08l.42,2.9a.56.56,0,0,0,.54.46l4.38,0A.55.55,0,0,0,43,55.6l.4-2.9a7.94,7.94,0,0,0,1.85-1.08L48,52.71a.54.54,0,0,0,.66-.24l2.18-3.8a.54.54,0,0,0-.13-.7ZM40.29,49a3.83,3.83,0,1,1,3.82-3.84A3.82,3.82,0,0,1,40.29,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.25,49.78,15,50.05a4.61,4.61,0,0,1-4.7-4.48L9.57,15.3A4.6,4.6,0,0,1,14,10.6l22.58-.52a4.59,4.59,0,0,1,4.69,4.47l.39,16.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.63,19.9a1.12,1.12,0,0,1,.91-.14,2.51,2.51,0,0,1,1.88,1.31,6,6,0,0,1,.68,2.14,9.36,9.36,0,0,1,.08,1.3,2.18,2.18,0,0,1-1.9,2.22l-.08,0-7.31.17a2.9,2.9,0,0,1-.9-.26,2.08,2.08,0,0,1-1.14-1.59,6.75,6.75,0,0,1,0-1.85,5.49,5.49,0,0,1,.34-1.44,3,3,0,0,1,1.19-1.57,2.74,2.74,0,0,1,1.28-.36.72.72,0,0,1,.32.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.16,14.19a3.29,3.29,0,1,1,.16,6.58,3.29,3.29,0,0,1-.16-6.58Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.34,
    y1: 15.56,
    x2: 37,
    y2: 15.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.45,
    y1: 20.37,
    x2: 37.11,
    y2: 20.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.57,
    y1: 25.18,
    x2: 37.22,
    y2: 24.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.28,
    y1: 31.66,
    x2: 34,
    y2: 31.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.39,
    y1: 36.52,
    x2: 29.3,
    y2: 36.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.5,
    y1: 40.87,
    x2: 24.6,
    y2: 40.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.61,
    y1: 45.68,
    x2: 24.71,
    y2: 45.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageSettings01);
export default __webpack_public_path__ + "static/media/Login_Page_Settings_01.9b0980736c2cc20fb1b495ef55e847f0.svg";
export { ForwardRef as ReactComponent };